import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 12\" id=\"arrow-left\"><path d=\"M7.41 1.41 6 0 0 6l6 6 1.41-1.41L2.83 6l4.58-4.59Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol